<template>
  <div>
    <el-dialog :visible.sync="addUseTimeBox" width="60%" :show-close="false" class="updateProductUseTimeDiglog">
      <div class="tableTitle" style="display: flex;align-items: center">
        <span style="width:1.7rem" class="label">日期</span>
        <span class="label" style="width:0.6rem">带出显示</span>
        <span class="label" style="width:2rem">产品名称</span>
        <span class="label" style="width:2.08rem">按时间维护</span>
        <span class="label" style="width:0.5rem">操作</span>

        <el-button @click="optimizeItinerary" style="margin-left: 100px" type="primary">AI优化行程</el-button>
      </div>
      <div style="position: absolute;">
        <div class="dayQuan" v-for="(item,index) in checkBudgetDetail.planDayList" :key="index" 
          @click="goToDay(item.planDay)" :style="item.planDay==checkPlanDay?'background: #da4e1a;color: #fff;':''">D{{item.planDay}}</div>
      </div>
      <div :style="'display: flex;overflow-y: scroll;margin-left: 0.4rem;height:'+height+'px'">
        <div>
          <div class="daybox" v-for="(item,index) in checkBudgetDetail.planDayList" :key="index" :id="'changeTimeDay'+item.planDay"
            @mouseover="checkPlanDay=item.planDay"  
            :style="item.planDay==checkPlanDay?'box-shadow: 0px 1px 10px 2px rgba(0, 0, 0, 0.4);':''">
            <div style="width: 1.7rem;">
              <label>{{dateFormatYMD(item.planDate,".")}}&nbsp;</label>
              <label>
                <span v-for="(item1,index1) in item.cityList" :key="index1">{{item1.cityName}}
                  <span v-if="index1!=(item.cityList.length-1)">-</span>
                </span>
              </label>
              <p style="margin-top:5px;">
                <a @click="addDesc(item)">添加当日文字描述</a>
              </p>
            </div>
            <div>
              <draggable v-model="item.budgetChangeTimeData" animation="300" @end="draggerEnd($event,item)">
                <transition-group>
                  <div v-for="(item1,index1) in item.budgetChangeTimeData" :key="index+'-'+index1" class="productBox">
                    <span class="labelone textspan" style="width:0.2rem;">
                      <span>
                        <el-checkbox v-model="item1.checkFlag" @change="changeData(item1)"></el-checkbox>
                      </span>
                    </span>
                    <span class="labelone textspan" style="width:2rem;">
                      <span v-if="item1.state!=11">
                        {{item1.resourceNameCn==''?item1.resourceNameEn:item1.resourceNameCn}}
                      </span>
                      <span v-else>
                        <el-input v-model="item1.resourceNameCn" @change="changeData(item1)" placeholder="请输入标题"></el-input>
                      </span>
                    </span>
                    <span class="labelone datespan" style="width:2.08rem"> 
                      <el-time-select placeholder="起始时间" clearable v-model="item1.budgetStartTime" size="mini" @change="changeData(item1)"
                        :picker-options="{start: '00:00',step: '00:15',end: '23:59',
                        minTime:(index1!=0)?item.budgetChangeTimeData[index1-1].budgetEndTime:''}">
                      </el-time-select>&nbsp;
                      <el-time-select placeholder="结束时间" clearable v-model="item1.budgetEndTime" size="mini" @change="changeData(item1)"
                        :picker-options="{start: '00:00',step: '00:15', end: '23:59',minTime: item1.budgetStartTime}">
                      </el-time-select>
                    </span>
                    <span class="labelone" style="width: 4rem;display: flex;">
                      <span v-if="item1.remark!=''" class="remarkSpan" @click="openTextDialog(item1)">{{item1.remark}}</span>
                      <span v-else style="font-size:12px;padding-right:10px;width: 3.6rem;display: inline-block;">
                        <el-link type="success" @click="openTextDialog(item1)">维护文字描述</el-link>
                      </span>
                      <a style="width:40px;" v-if="item1.state==11" @click="handleDelete(index1,item1,item)">&nbsp;删除</a>
                      <a style="width:40px;" v-if="item1.state==11" @click="copyText(item1,item)">&nbsp;复制</a>
                    </span>
                  </div>
                </transition-group>
              </draggable>
            </div>  
          </div>
        </div>
      </div>
      <div style="justify-content: center;display: flex;padding: 0.1rem;">
        <div>
          <el-button @click="addUseTime" class="savebuttom">保存</el-button>
          <el-button @click="closeDialog" class="savebuttom" style="margin-left:75px;">关闭</el-button>
          <el-button @click="deleteAllTime" class="savebuttom" style="margin-left:75px;">删除所有时间</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="copyToOtherDay" width="12%">
      <el-checkbox-group v-model="checkDayList">
        <div v-for="(item,index) in checkBudgetDetail.planDayList" :key="index">
          <el-checkbox :label="item.planDay" v-if="item.planDay!=checkObj.day">D{{item.planDay}}</el-checkbox>
        </div>
      </el-checkbox-group>
      <span slot="footer" class="dialog-footer">
        <el-button @click="copyToOtherDay = false">取 消</el-button>
        <el-button type="primary" @click="sureCopy">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="textEditDialog" width="40%">
      <el-input type="textarea" placeholder="请输入内容" v-model="textEdit" autosize style=" margin-top: 0.3rem;"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="textEditDialog = false">取 消</el-button>
        <el-button type="primary" @click="textSure">确 定</el-button>
      </span>
    </el-dialog>
      <DialogMobileChat ref="DialogMobileChat"></DialogMobileChat>
  </div>
</template>

<script>
import PlanApi from '@/components/Api/PlanApi.js'
import draggable from 'vuedraggable'
import { getBudgetInfo } from '../../js/function'
import DialogMobileChat from "@/components/ChatGPT3.0/DialogMobileChat.vue";
export default {
  components:{DialogMobileChat, draggable},
  data(){
    return{
      addUseTimeBox:false,
      height:0,
      checkPlanDay:0,
      checkDayList:[],
      copyToOtherDay:false,
      checkObj:{},
      editObj:{},
      textEditDialog:false,
      textEdit:'',
    }
  },
  props:{
    checkBudgetDetail:{
      type:Object,
      default:()=>{return {}}
    }
  },
  methods:{
    optimizeItinerary() {
        let obj = {
            // startDate: '',
            // endDate: '',
            // number: 2,
        }
        this.$refs.DialogMobileChat.init(obj,3)
    },
    openTextDialog(item1){
      this.textEditDialog = true;
      this.editObj = item1
      this.textEdit = item1.remark
    },
    textSure(){
      this.textEditDialog = false;
      this.$set(this.editObj,'isUpdate',true)
      this.$set(this.editObj,'remark',this.textEdit)
    },
    copyText(item,item1){
      this.checkDayList = []
      this.copyToOtherDay = true,
      this.checkObj = item
      this.checkPlanDay = item1.planDay
    },
    sureCopy(){
      this.checkBudgetDetail.planDayList.forEach(e=>{
        if(this.checkDayList.indexOf(e.planDay)!=-1){
          var obj = JSON.parse(JSON.stringify(this.checkObj))
          this.$set(obj,'day',e.planDay)
          this.$set(obj,'stayDate',e.planDate)
          this.$set(obj,'endStayDate',e.planDate)
          obj.isUpdate=true
          obj.budgetIds=[]
          obj.id=null
          e.budgetChangeTimeData.push(obj)
        }
      })
      this.copyToOtherDay=false
    },
    deleteAllTime(){
      this.checkBudgetDetail.planDayList.forEach(element => {
        element.budgetChangeTimeData.forEach(e=>{
          this.$set(e,'budgetStartTime',null)
          this.$set(e,'budgetEndTime',null)
          e.isUpdate=true
        })
      });
    },
    handleDelete (index, row,item) {
      if(row.id!==null){
        this.$confirm('此操作将会永久删除该数据不可恢复，您确定要删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {      
          new PlanApi('plan').budgetDelete({budgetMainId:[this.checkBudgetDetail.id],budgetDetailIds:[],budgetIds:row.budgetIds}).then(res => {
            if (res.status == 200) {
              this.$message({type:"success",message:"删除成功"})
              item.budgetChangeTimeData.splice(index,1)
            }else{
              this.$message({type:"error",message:res.statusText})
            }
          })   
        }).catch((err) => {})
      }else{
        item.budgetChangeTimeData.splice(index,1)
      }
    },
    openBefore(){
      this.addUseTimeBox = true;
      new PlanApi('plan').changeTimeBudgetlist({budgetMainId:this.checkBudgetDetail.id}).then(res => {
        if (res.status == 200) {
          this.checkBudgetDetail.planDayList.forEach(element => {
            var budgetDetails = res.data.filter(item=>item.day==element.planDay)
            budgetDetails.forEach(ee=>{
              this.$set(ee,'editstatus',false)
              this.$set(ee,'checkFlag',ee.isCheck===1?true:false)
              this.$set(ee,'budgetStartTime',this.dateFormatHM(ee.stayDate)=='00:00'?'':this.dateFormatHM(ee.stayDate))
              this.$set(ee,'budgetEndTime',this.dateFormatHM(ee.endStayDate)=='00:00'?'':this.dateFormatHM(ee.endStayDate))
            })
            this.$set(element,'budgetChangeTimeData',budgetDetails)
          });
        }else{
          this.$message({type:"error",message:res.statusText})
        }
      })
    },
    closeDialog(){
      this.addUseTimeBox=false
      getBudgetInfo(this.checkBudgetDetail.id)
    },
    addUseTime(){
      var dataList=[]
      this.checkBudgetDetail.planDayList.forEach(e=>{
        e.budgetChangeTimeData.forEach(ee=>{
          if(ee.isUpdate){
            ee.isCheck = ee.checkFlag?1:0
            if(ee.budgetStartTime&&ee.budgetStartTime!=''){
              ee.stayDate = this.dateFormatYMD(e.planDate,"-")+" "+ee.budgetStartTime+":00"
            }else{
              ee.stayDate = this.dateFormatYMD(e.planDate,"-")+" 00:00:00"
            }
            if(ee.budgetEndTime&&ee.budgetEndTime!=''){
              ee.endStayDate = this.dateFormatYMD(e.planDate,"-")+" "+ee.budgetEndTime+":00"
            }else{
              ee.endStayDate = this.dateFormatYMD(e.planDate,"-")+" 00:00:00"
            }
            if(ee.budgetIds&&ee.budgetIds.length>1){
              ee.budgetIds.forEach(eee=>{
                var obj = JSON.parse(JSON.stringify(ee))
                obj.id = eee;
                dataList.push(obj)
              })
            }else{
              dataList.push(ee)
            }
          }
        })
      })
      if(dataList.length>0){
        new PlanApi('plan').updateBudget(dataList).then(res => {
          if (res.status == 200) {
            this.$message({type:"success",message:"保存成功"})    
            this.openBefore();
          }else{
            this.$message({type:"error",message:res.statusText})
          }
        })   
      }else{
        this.$message({type:"success",message:"保存成功"})    
      }
    },
    changeData(item1){
      this.$set(item1,"isUpdate",true)
    },
    addDesc(item){
      var obj = {
        state:11,
        resourceId:0,
        resourceNameCn:'',
        remark:'',
        productType:0,
        budgetStartTime:'',
        budgetEndTime:'',
        id:null,
        day:item.planDay,
        stayDate:item.planDate,
        endStayDate:item.planDate,
        editstatus:true,
        checkFlag:true,
        budgetMainId:this.checkBudgetDetail.id,
        planId:this.checkBudgetDetail.planId
      }
      item.budgetChangeTimeData.push(obj)
    },
    goToDay(planDay){
      this.checkPlanDay=planDay
      document.getElementById('changeTimeDay'+planDay).scrollIntoView()
    },
    draggerEnd(e,item){
      item.budgetChangeTimeData.forEach((ee,index)=>{
        ee.sort = (index+1)
        this.$set(ee,"isUpdate",true)
      })
    }
  },
  mounted(){
    this.height = document.documentElement.clientHeight-183;
  }
}
</script>

<style lang="scss" scoped>
.updateProductUseTimeDiglog{
  /deep/ .el-dialog__body{
    background-color: #F7F7F7;
    padding-bottom: 0rem;
    position: relative;
  }
  /deep/ .el-dialog__header{
    padding:0;
  }
  /deep/ .el-dialog{
    margin-top:10vh !important;
  }
  font-size:0.12rem;
  .tableTitle{
    display:flex;
    margin-bottom:10px;
    padding-top:20px;
    margin-left: 0.5rem;
  }
  .remarkSpan{
    font-size: 12px;
    padding-right: 10px;
    width: 3.5rem;
    display: block;
    white-space: nowrap;
    overflow: hidden;
    border-bottom: 1px solid;
    padding-bottom: 5px
  }
  .dayQuan{
    width: 0.4rem;
    height: 0.4rem;
    border-radius: 50%;
    font-weight: bold;
    text-align: center;
    line-height: 0.4rem;
    background: #fff;
    color: #000;
    margin-bottom: 0.1rem;
    cursor: pointer;
  }
  .daybox{
    background-color: white;
    margin: 0 0 10px 10px;
    display: flex;
    color: black;
    padding: 0.1rem;
    /deep/ .el-input__inner{
      width: 100%;
      height: 0.27rem;
      border: none;
      border-bottom: 1px solid #000;
      border-radius: 0px;
    }
    .productBox{
      margin-bottom: 5px;
      box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.18);
      display: flex;
      padding: 0.05rem;
      align-items: center;
      .datespan{
        display: flex;
        /deep/ .el-input__inner{
          width: 0.9rem;
          padding-right: 0px;
          border: none;
        }
      }
    }
  }
}
</style>